import script from "./AccountForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountForm.vue?vue&type=script&lang=ts&setup=true"

import "./AccountForm.vue?vue&type=style&index=0&id=35e820c1&lang=css"

export default script